import React               from 'react';
import UserManagerInstance from '../../configs/login/UserManagerInstance';

const SilentRenewToken =  () => {
    console.log('silent renewing token...');
    UserManagerInstance.signinSilentCallback();
    return <br/>;
};

export default SilentRenewToken;